import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'changePassword.title',
    defaultMessage: 'Change password',
  },
  description: {
    id: 'changePassword.description',
    defaultMessage: 'To reset your account password, enter a new one below.',
  },
  fieldLabel: {
    id: 'changePassword.fieldLabel',
    defaultMessage: 'New password',
  },
  buttonLabel: {
    id: 'changePassword.buttonLabel',
    defaultMessage: 'Confirm',
  },
  fieldRequired: {
    id: 'changePassword.fieldRequired',
    defaultMessage: 'This field is required',
  },
});
